import React from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { Grid } from '@mui/material';
import { ChapterWithNumber } from '../../types/document';
import EditorChapter from './EditorChapter';
import useStore from '../../store/storeContext';

interface StoreState {
    showSubAreas: boolean;
    chapters: ChapterWithNumber[];
    toggleShowSubAreas: () => void;
}

function DocumentChapters() {
    const { document } = useStore();

    const localStore = useLocalObservable<StoreState>(() => ({
        showSubAreas: false,

        get chapters(): ChapterWithNumber[] {
            let chaptersWithChapterNumbers = document.getChaptersWithNumbers();

            if (!this.showSubAreas) {
                chaptersWithChapterNumbers = chaptersWithChapterNumbers.filter(
                    (chapterWithNumber) => !chapterWithNumber.chapter.isCompareToCountiesSubArea,
                );
            }
            return chaptersWithChapterNumbers;
        },

        toggleShowSubAreas(): void {
            this.showSubAreas = !this.showSubAreas;
        },
    }));

    return (
        <Grid container spacing={6}>
            {localStore.chapters.map((chapterWithNumber) => (
                <Grid
                    item
                    xs={12}
                    key={chapterWithNumber.chapter.id}
                    id={'chapter-' + chapterWithNumber.chapter.orderNumber}
                >
                    <EditorChapter
                        chapter={chapterWithNumber.chapter}
                        chapterNumber={chapterWithNumber.chapterNumber}
                        showSubAreas={localStore.showSubAreas}
                        toggleShowSubAreas={localStore.toggleShowSubAreas}
                    />
                </Grid>
            ))}
        </Grid>
    );
}

export default observer(DocumentChapters);
